import { useRef } from "react";
import UserfulTooltip from "../../Widgets/UserfulTooltip";

interface IProps {
    name?: string;
}

export default function CardName({ name = "" }: IProps) {
    const nameRef = useRef<HTMLSpanElement>(null);

    return (
        <UserfulTooltip title={name} placement="top">
            <div className="userful-card-name-wrapper">
                <span className="userful-card-name" ref={nameRef}>
                    {name}
                </span>
            </div>
        </UserfulTooltip>
    );
}
